module.exports = __webpack_public_path__ + "assets/roboto-condensed-v16-latin-regular.svg?92012ce044dbc6ee9ac490204ed9f3ef";